/**
 * It contains backend Apis for social media accounts.
 * All Ayrshare calls go through the Express backend proxy.
 */

import axiosProxy from "@/api/axios/axios_express_proxy";

/**
 * Create merchant Ayrshare account
 */
export function createAyrshareAccount(data) {
  return axiosProxy.post('/api/ayrshare/profiles', {
    title: data.merchantId.toString()
  });
}

/**
 * Get Ayrshare onboarding link for social account connection
 */
export function getAyrshareOnboardingLink(data) {
  return axiosProxy.post('/api/ayrshare/onboarding-link', {
    profileKey: data.profileKey,
  });
}

/**
 * Get connected social media accounts
 */
export function getAyrshareUserInfo(data) {
  return axiosProxy.get('/api/ayrshare/user', {
    params: { profileKey: data.profileKey }
  });
}

/**
 * Disconnect social media account
 */
export function disconnectSocialMediaAccount(key, platform) {
  return axiosProxy.delete('/api/ayrshare/social', {
    data: {
      platform: platform,
      profileKey: key
    }
  });
}
